<template>
    <div class="popup-wrapper" :class="customClass"  @touchmove.prevent>
        <!-- 蒙层 -->
        <transition name="fade">
            <div v-show="visible" class="popup-overlay" @click="handleClose"></div>
        </transition>

        <!-- 弹出层 -->
        <transition name="slide">
            <div v-show="visible" class="popup-container" :style="{ minHeight: height }">
                <header class="popup-header" @click="handleClose">
                    <span class="title">{{ title }}</span>
                    <img class="close-icon" src="../assets/icons/icon-close.png" />
                </header>

                <div class="popup-content">
                    <slot></slot>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        customClass: {
            type: String,
            default: ''
        },
        height: {
            type: String,
            default: '7.4375rem'
        }
    },

    methods: {
        handleClose() {
            this.$emit('close')
        }
    }
}
</script>

<style lang="less" scoped>
* {
    box-sizing: border-box;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.slide-enter,
.slide-leave-active {
    transform: translate3d(0, 100%, 0);
}

.popup-wrapper {
    .popup-overlay {
        z-index: 1000;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #000000;
        opacity: 0.5;
    }

    .popup-container {
        z-index: 10001;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: #ffffff;
        transition: transform 0.3s;

        .popup-header {
            display: flex;
            align-items: center;
            width: 100%;
            height: 3.0625rem;
            padding: 1.1875rem .6875rem;

            .close-icon {
                position: absolute;
                top: .875rem;
                right: .6875rem;
                width: .625rem;
                height: .625rem;
            }

            .title {
                flex: 1;
                text-align: center;
                font-size: 0.9375rem;
                font-weight: 400;
                font-weight: 400;
                font-family: SF UI Display;
                color: #2D2F32;
            }
        }

        .popup-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 0 .6875rem;
            padding-bottom: constant(safe-area-inset-bottom);
            padding-bottom: env(safe-area-inset-bottom);
        }
    }
}
</style>



// WEBPACK FOOTER //
// BasicPopup.vue?6d04cfe2